import { DatePipe, NgClass, TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-success-purchase-modal',
  imports: [MatIcon, MatButton, NgClass, DatePipe, TitleCasePipe],
  templateUrl: './success-purchase-modal.component.html',
  styleUrl: './success-purchase-modal.component.scss',
})
export class SuccessPurchaseModalComponent {
  public readonly data = inject<{ name: string; period: number }>(
    MAT_DIALOG_DATA
  );
  public readonly matDialogRef = inject(
    MatDialogRef<SuccessPurchaseModalComponent>
  );
}
